import { useEffect, Fragment } from 'react';
import { format, parseISO } from 'date-fns';
import { getDayFromDate } from '@translations/functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { useLazyGetOrderTimelineQuery } from '@api/shipping-data/detailApi';
import ErrorElement from 'components/base-elements/error/ErrorElement';
import LoadingElement from 'components/base-elements/loading/LoadingElement';



interface OrderTimelineProps {
	orderUnvId: string | null | undefined,
}


export const OrderTimeline = (props: OrderTimelineProps) => {
	const { orderUnvId } = props;

	const [ getOrderTimeline, { data, isLoading, isFetching, isError }] = useLazyGetOrderTimelineQuery();


	const getStatusColor = (eventTypeEn: string) => {
		if (eventTypeEn === 'Order reduced'
			|| eventTypeEn === 'Order rescheduled'
			|| eventTypeEn === 'Delivery reduced'
			|| eventTypeEn === 'Delivery rescheduled')
			return ' status-warning';
		return ''
	}


	const getFormatedTimestamp = (timeStamp: string | null | undefined) => {
		if (!timeStamp) return '-';
		
		const parsedTimeStamp = parseISO(timeStamp);
		const parsedTimeStampDay = parsedTimeStamp ? getDayFromDate(parsedTimeStamp).toUpperCase() : null;
		const result = parsedTimeStamp && parsedTimeStampDay
			? `${format(parsedTimeStamp, 'HH:mm')} ${parsedTimeStampDay} ${format(parsedTimeStamp, 'd.M.yyyy')}`
			: '-';
		return result;
	}


	useEffect(() => {
		if (orderUnvId) {
			getOrderTimeline({ unversionedSystemId: orderUnvId }, true);
		}
	}, [ orderUnvId ]);


	if (isError) return (
		<div className='detail-area-empty'>
			<ErrorElement />
		</div>
	);

	
	if (isLoading || isFetching) return (
		<div className='detail-area-empty'>
			<LoadingElement />
		</div>
	);

	
	if (!orderUnvId || !data || data.length === 0) return (
		<p className='detail-area-empty'>Žádná data k dispozici</p>
	);


	return (
		<div className={`order-timeline-block`}>
			{data.map(x =>
				<Fragment key={`${x.eventType}-${x.timeStamp}`}>
					<div className={`order-timeline-type${getStatusColor(x.eventType.en)}`}>
						<div><FontAwesomeIcon icon={faAngleUp} /></div>
						{x.eventType && x.eventType.cs &&
							<p>{x.eventType.cs}</p>
						}
					</div>
					<div className={`order-timeline-text${getStatusColor(x.eventType.en)}`}>
						<p>{getFormatedTimestamp(x.timeStamp)}</p>
						{x.eventText && x.eventText.cs &&
							<p>{x.eventText.cs}</p>
						}
					</div>
				</Fragment>
			)}
		</div>
	)
}